<template>
    <div class="tabs">
        <ul class="tabs__nav">
            <li class="tabs__nav-item">
                <custom-button type="button" @click="tab = tabList" class="tabs__nav-button"
                               v-bind:class="{'active': tab === tabList}">
                    Nahrané obrázky
                </custom-button>
            </li>
            <li class="tabs__nav-item">
                <custom-button type="button" @click="tab = tabUpload" class="tabs__nav-button"
                               v-bind:class="{'active': tab === tabUpload}">
                    Nahrát
                </custom-button>
            </li>
        </ul>
        <div class="tabs__content">
            <div v-if="tab === tabList">
                <template v-if="images.length">
                    <image-media-list :picker="picker" :selected="selectedImages" @pick="pick"/>
                    <div class="tabs__controls z1" v-if="picker">
                        <custom-button type="button" @click="insertImages" small outline
                                       :disabled="selectedImages.length === 0">
                            Vložit {{ selectedImages.length }}
                            {{ selectedImages.length|inflection(['obrázek', 'obrázky', 'obrázků']) }}
                        </custom-button>
                        <custom-button type="button" @click="$emit('close')" iconic noicon>
                            Zrušit
                        </custom-button>
                    </div>
                </template>
                <div v-if="images.length === 0" class="info">
                    <p class="info-text">
                        Váš projekt neobsahuje žádné obrázky.
                        <custom-button class="text-button text--info" @click="tab = tabUpload">Nahrajte první obrázek.
                        </custom-button>
                    </p>
                </div>
            </div>
            <div v-if="tab === tabUpload">
                <image-uploader @complete="uploadComplete"/>
            </div>
        </div>
    </div>
</template>

<script>
import ImageUploader from '../../../../components/Uppy/ImageUploader';
import CustomButton from '../../../../components/Button/CustomButton';
import ImageMediaList from './ImageList';

const TAB_LIST = 'list';
const TAB_UPLOAD = 'upload';

export default {
    name:       'ImageMediaContainer',
    components: {CustomButton, ImageUploader, ImageMediaList},
    props:      {
        picker:         {
            type:     Boolean,
            required: false,
            default:  () => false,
        },
        multipleSelect: {
            type:     Boolean,
            required: false,
            default:  () => false,
        },
        selected:       {
            type:     Array,
            required: false,
            default:  () => [],
        },
    },
    data:       () => {
        return {
            tabList:        TAB_LIST,
            tabUpload:      TAB_UPLOAD,
            tab:            TAB_LIST,
            selectedImages: [],
        }
    },
    mounted() {
        this.selectedImages = this.selected;
    },
    computed:   {
        images() {
            return this.$store.getters['media/images'];
        }
    },
    methods:    {
        pick(imageId) {
            if (this.multipleSelect) {
                const index = this.selectedImages.indexOf(imageId);
                if (index !== -1) {
                    this.selectedImages.splice(index, 1);
                } else {
                    this.selectedImages.push(imageId);
                }
            } else {
                this.selectedImages = [imageId];
            }
        },
        uploadComplete(data) {
            const {failed} = data;
            if (failed.length === 0) {
                this.tab = TAB_LIST;
            }
        },
        insertImages() {
            this.$emit('o3-select', {imageIds: this.selectedImages});
        }
    }
}
</script>


